import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoOperacaoVendaMultiselectComponent } from './novo-operacao-venda-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoOperacaoVendaMultiselectComponent],
  exports: [NovoOperacaoVendaMultiselectComponent]
})
export class NovoOperacaoVendaMultiselectModule {}
